import { ProjectSummaryContainer } from '@/containers/ConferenceTag.Summary/Project';
import { useProjectOrLatestChild } from '@/containers/GroupProject/hooks';
import * as Insights from './Insights';

type Props = unknown;

export const ProjectSummary = (props: Props) => {
  const project = useProjectOrLatestChild();

  return (
    <ProjectSummaryContainer projectId={project.id}>
      <Insights.Panel
        actionsEnabled={false}
        projectId={project.id} />
    </ProjectSummaryContainer>
  );
};

ProjectSummary.displayName = 'Project.Summary';